import Hotjar from "@hotjar/browser";
import { HOTJAR_SITE_ID, IS_POC, IS_SELF_HOSTED } from "@/constants/constants";
import { clearVendorStorage } from "@/services/consent/storage-cleanup";

const HOTJAR_VERSION = 6;
const HOTJAR_STORAGE_PREFIXES = ["_hj"] as const;

let isInitialized = false;

/**
 * Hotjar only runs where the build supplies `VITE_APP_HOTJAR_SITE_ID`, and
 * never self-hosted or in a POC — those must not reach the public Hotjar CDN.
 */
const isHotjarEnabled = () => HOTJAR_SITE_ID > 0 && !IS_SELF_HOSTED && !IS_POC;

/**
 * Injects the Hotjar tag. Only the consent service calls this, once the user
 * has accepted the analytics category. Repeat calls are no-ops.
 */
const initHotjar = () => {
	if (isInitialized || !isHotjarEnabled()) return;

	try {
		Hotjar.init(HOTJAR_SITE_ID, HOTJAR_VERSION);
		isInitialized = true;
	} catch {
		// Intentionally ignored: an ad-blocker or a CDN failure is not an app error.
	}
};

/**
 * Hotjar has no consent or shutdown API: delete what it stored, and the
 * consent service reloads the page so the injected tag is gone.
 */
const teardownHotjar = () => {
	clearVendorStorage(HOTJAR_STORAGE_PREFIXES);
	isInitialized = false;
};

export { initHotjar, isHotjarEnabled, teardownHotjar };
